module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-select', {
    attrs: {
      "items": _vm.filteredStatusList,
      "item-text": "description",
      "item-value": "id",
      "item-disabled": "disabled",
      "return-object": "",
      "label": _vm.label,
      "clearable": ""
    },
    on: {
      "input": _vm.handleSelection,
      "click:clear": _vm.handleSelection
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item.description)
          }
        })] : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1)
},staticRenderFns: []}